import Select from '../../common/Select';
import { connect } from 'react-redux';
import { selectListDropdownChange } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    value: question.values[0],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(selectListDropdownChange(e.target.value, ownProps.questionId)),
});

const SelectListDropdown = connect(
  mapStateToProps,
  mapDispatchToProps
)(Select);

export default SelectListDropdown;
